import * as _ from 'underscore';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Sites } from '../resources/Sites';
import { ServerService } from '../services/ServerService';
import {
  IAuthenticationProvider,
  ISiteAuthenticationSettings,
  SiteAuthenticationSettingsService,
} from '../services/SiteAuthenticationSettingsService';

export interface IAuthenticationProviderSelectorModel {
  authenticationProviderIds: string[]; // INPUT - array form is needed for radio-button tri-state behavior
  authenticationProvider?: IAuthenticationProvider; // OUTPUT - will be set to the selected provider
  authSetting?: string; // should be removed by TFSID:607630
  getProviderDescription?: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string;
  getProviderDisplayName?: (provider: IAuthenticationProvider) => string;
}

interface IAuthenticationProviderSelectorScope extends ng.IScope {
  defaultProvider: IAuthenticationProvider;
  enabledExternalProviders: IAuthenticationProvider[];
  getProviderDescription: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string;
  getProviderDisplayName: (provider: IAuthenticationProvider) => string;
  inviteNotificationEnabledForSite?: boolean;
  model: IAuthenticationProviderSelectorModel;
}

Module.instance().directive('tbAuthenticationProviderSelector', <any[]>[
  '$sanitize',  // used by ngBindHtml
  '$translate',
  'SiteAuthenticationSettingsService',
  'Sites',
  'ServerService',
  ($sanitize: ng.sanitize.ISanitizeService, $translate: ng.translate.ITranslateService, siteAuthenticationSettingsService: SiteAuthenticationSettingsService, Sites: Sites, ServerService: ServerService) => {
    const defaultDisplayName = (provider: IAuthenticationProvider) => siteAuthenticationSettingsService.getProviderDisplayName(provider);
    const defaultDescription = (provider: IAuthenticationProvider) => '';
    return {
      restrict: 'E',
      templateUrl: 'tbAuthenticationProviderSelector.html',
      replace: true,
      scope: {
        model: '=', // establishes two-way binding with parent scope
      },
      link: (scope: IAuthenticationProviderSelectorScope, element: JQuery, attr: ng.IAttributes) => {
        scope.getProviderDescription = scope.model.getProviderDescription || defaultDescription;
        scope.getProviderDisplayName = scope.model.getProviderDisplayName || defaultDisplayName;
        Sites.getCurrentSiteSettingsForSiteAdmin()
            .then((data: any) => {
                scope.inviteNotificationEnabledForSite = data.siteAdminSettings.siteInviteEmailEnabled;
            });

        siteAuthenticationSettingsService.getSiteAuthenticationSettings().then((settings: ISiteAuthenticationSettings) => {
          const setProvider = (id: string) => {
            scope.model.authenticationProvider = siteAuthenticationSettingsService.findProvider(settings, id);
            scope.model.authSetting = siteAuthenticationSettingsService.getAuthSetting(id, settings);
          };

          scope.defaultProvider = settings.defaultProvider;
          scope.enabledExternalProviders = _.filter(settings.externalProviders, (provider: IAuthenticationProvider) => provider.isEnabled);
          scope.model.authenticationProviderIds = scope.model.authenticationProviderIds || [settings.defaultProvider.id];

          if (scope.enabledExternalProviders.length === 0) {
            setProvider(scope.defaultProvider.id);
          } else {
            scope.$watch('model.authenticationProviderIds', (newVal: string[], oldVal: string[]) => {
              const ids = Set.fromKeyArray(newVal);
              if (ids.size() === 1) {
                setProvider(ids.first());
              }
            });
          }
        });
      }
    };
  }
]);
